export function getCurrentUrl() {
  if (!window) {
    return;
  }
  const host = window.location.hostname;
  const protocol = window.location.protocol;
  const path = window.location.pathname;
  const uri = encodeURI(`${protocol}//${host}${path}`);
  return uri;
}

export function replaceURLWithCurrentDomain(srcURL) {
  const url = new URL(srcURL);
  if (url.hostname.indexOf('namastream') !== -1) {
    url.hostname = 'app.namastream.com';
  } else if (url.hostname.indexOf('heymarvelous') !== -1) {
    url.hostname = 'app.heymarvelous.com';
  } else {
    url.hostname = window.location.hostname;
  }
  return url.href;
}

export function replaceRedirectURLWithCurrentDomain(srcURL) {
  const currentUrl = new URL(window.location.href);
  const url = new URL(srcURL);
  if (currentUrl.hostname.indexOf('namastream') !== -1) {
    url.hostname = currentUrl.hostname;
  } else if (currentUrl.hostname.indexOf('heymarvelous') !== -1) {
    url.hostname = currentUrl.hostname;
  } else {
    url.hostname = window.location.hostname;
  }
  return url.href;
}

export function isOfficialDomain(host) {
  return (
    host.indexOf('namastream') !== -1 ||
    host.indexOf('heymarv') !== -1 ||
    host.indexOf('127.0.0.1') !== -1 ||
    host.indexOf('localhost') !== -1
  );
}
